var _path, _rect, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetAllowed = function SvgPetAllowed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.977 7.749q-.001.123.052.234c.24.48.585.876.748 1.517.355 1.395.586 4.427-1.755 6.071-2.06 1.448-5.54 2.322-6.76 2.429h-.531c-1.064 0-4.626-.934-6.753-2.429C.638 13.927.868 10.895 1.222 9.5c.144-.565.506-1.028.749-1.518a.5.5 0 0 0 .052-.234V2.21c0-.483.562-.749.935-.442L6.603 4.76a.59.59 0 0 0 .558.099c1.028-.346 1.846-.497 2.605-.558h.474c.728.075 1.642.244 2.598.559a.59.59 0 0 0 .559-.1l3.644-2.992a.572.572 0 0 1 .936.442z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 5,
    y: 9,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 13,
    y: 9,
    fill: "currentColor",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M10.6 13H9.037a.02.02 0 0 0-.016.031l.741 1.112c.113.17.363.17.476 0l.741-1.112a.02.02 0 0 0-.016-.031z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.2 14.7c.926.309 1.852-.273 1.852-1.509"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.904 14.7c-.926.309-1.853-.273-1.853-1.509"
  })));
};
export default SvgPetAllowed;